import PropTypes from 'prop-types';
import { useNavInfoContext } from 'providers/NavInfoProvider';
import React from 'react';
import styled from 'styled-components';

const Dimmer = styled.div`
  position: fixed;
  height: 200vh;
  width: 100vh;
  left: 0;
  top: 80px;
  background: rgba(51, 51, 73, 0.7);
  visibility: hidden;
  z-index: 1;
  transition: 0.2s ease;
`;

const MobileMenuDropdown = styled.div`
  width: 100%;
  position: fixed;
  top: 64px;
  left: 0;
  z-index: 5;
  box-shadow: 0 16px 30px 0 rgba(102, 138, 184, 0.1);
  transition: transform 0.2s ease;
  background-color: white;
`;

export const MobileMenuItem = styled.a`
  height: 20px;
  color: #202325;
  font-size: 15px;
  padding: 20px 20px;
  display: block;
  cursor: pointer;
  font-weight: 600;
`;

const MobileMenu = ({ children }) => {
  const {
    isMobileMenuOpen,
    setIsMobileMenuOpen,
    setIsSearchFieldExpandInMobile,
  } = useNavInfoContext();

  return (
    <>
      <Dimmer
        style={{
          position: 'fixed',
          visibility: isMobileMenuOpen ? 'visible' : 'hidden',
          opacity: isMobileMenuOpen ? '1' : '0',
        }}
        onClick={() => {
          setIsMobileMenuOpen(false);
          setIsSearchFieldExpandInMobile(false);
        }}
      />

      <MobileMenuDropdown
        style={{
          position: 'fixed',
          transform: isMobileMenuOpen ? '' : 'translate(0px, -800px)',
        }}
      >
        {children}
      </MobileMenuDropdown>
    </>
  );
};

MobileMenu.propTypes = {
  children: PropTypes.node,
};

export default MobileMenu;
